import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Channel = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Channel' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,9 L22,9 L22,22 L2,22 L2,9 Z M21,2 L13,9 L11,9 L3,2' />
  </StyledIcon>
);
